<template>
  <BreadCrumb PageTitle="Stock Alerts" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <StockAlertContent />
    </div>
  </div>
</template>

<script setup>
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import StockAlertContent from "../../components/Admin/StockAlert/StockAlertContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>
